import React from 'react';
import { Navigate } from 'react-router-dom';
import { getStoredUser } from '../api';

// requiredRole: nese vendoset ('admin'), vetem ai rol lejohet; perndryshe çdo user i kycur kalon
export default function ProtectedRoute({ children, requiredRole }) {
  const user = getStoredUser();
  const token = localStorage.getItem('wsa_token');

  if (!token || !user) return <Navigate to="/admin/login" replace />;
  if (requiredRole && user.role !== requiredRole) {
    return <Navigate to={user.role === 'admin' ? '/admin/clients' : '/admin/skica'} replace />;
  }
  return children;
}
